// extracted by mini-css-extract-plugin
module.exports = {"accordionComponentWrapper":"q_","header":"ra","accordionWrapper":"rb","accordionHeader":"rc","accordionIcon":"rd","accordionContent":"re"};